import { render, staticRenderFns } from "./GameStepper.vue?vue&type=template&id=527f85a8&scoped=true&"
import script from "./GameStepper.vue?vue&type=script&lang=ts&"
export * from "./GameStepper.vue?vue&type=script&lang=ts&"
import style0 from "./GameStepper.vue?vue&type=style&index=0&id=527f85a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f85a8",
  null
  
)

export default component.exports